export function Sticker(props: any) {
  return (
    <div
      style={{
        position: "fixed",
        width: "fit-content",
        margin: "auto",
        top: "90%",
        left: "0",
        right: "0",
      }}
    >
      {props.children}
    </div>
  );
}
